import { Group } from '@mantine/core';
import { IconLayoutList } from '@tabler/icons-react';
import P2Regular from 'components/typography/P2Regular';

/** Displays the configured section reference consistently with other object cells. */
export default function SectionColumn({ data }: { data: { sectionName: string } }) {
  return (
    <Group spacing={8} noWrap>
      <IconLayoutList stroke={1.5} />
      <P2Regular color="gray.8">{data.sectionName}</P2Regular>
    </Group>
  );
}
